var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SPINNER x-spin",class:`bd-l-${_vm.color}`,style:(`width:${_vm.size}; height:${_vm.size}; border-left-width:2px!important;`)})
}
var staticRenderFns = []

export { render, staticRenderFns }